import { ICollaboration } from '@descomplica/microfrontend-core';
import { injectable } from 'tsyringe';

import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';
import { PegasusGateway } from '@/infrastructure/gateways/classroom/pegasus.gateway';

import {
  RecordVideoWatchingUnexpectedError,
  VideoWatchingNotRecordedBecauseStudentNotFound,
  VideoWatchingRecorded,
} from './record-video-watching.collaboration.responses';

export enum WatchingLocation {
  Library = 'library',
  StudyPlan = 'study plan',
}

interface Params {
  topicGuid: string;
  lessonGuid: string;
  videoGuid: string;
  watchingLocation: WatchingLocation;
}

const VIDEO_WATCHING_NOT_RECORDED_BECAUSE_STUDENT_NOT_FOUND =
  'VideoWatchingNotRecordedBecauseStudentNotFound';

@injectable()
export class RecordVideoWatchingCollaboration
  implements ICollaboration<Params, Promise<CollaborationResult>>
{
  constructor(private pegasusGateway: PegasusGateway) {}

  async run({
    topicGuid,
    lessonGuid,
    videoGuid,
    watchingLocation,
  }: Params): Promise<CollaborationResult> {
    const { data, error } = await this.pegasusGateway.recordVideoWatching(
      topicGuid,
      lessonGuid,
      videoGuid,
      watchingLocation,
    );

    if (data && !error) return new VideoWatchingRecorded();

    if (error) {
      switch (error.data.identifier) {
        case VIDEO_WATCHING_NOT_RECORDED_BECAUSE_STUDENT_NOT_FOUND:
          return new VideoWatchingNotRecordedBecauseStudentNotFound();
      }
    }

    return new RecordVideoWatchingUnexpectedError();
  }
}
